<template>
  <div class="container div-bg">
    <b-row align-h="center">
      <b-col cols="2">
        <div class="cols-div">
          <img
            class="img-ico"
            src="@/assets/images/contact-advisory-phone.png"
          />
          <p class="p-title text-center">电话咨询</p>
          <p class="p-phone text-center">{{ phone }}</p>
        </div>
      </b-col>
      <b-col cols="1"> </b-col>
      <b-col cols="2">
        <div class="cols-div">
          <img
            class="img-ico"
            src="@/assets/images/contact-advisory-weixin.png"
          />
          <p class="p-title text-center">微信咨询</p>
          <p class="p-phone text-center">添加服务微信</p>
          <b-button class="btn-from text-center" id="popoverFirst"
            >二维码</b-button
          >
          <b-popover
            target="popoverFirst"
            placement="top"
            triggers="hover focus"
          >
            <img
              src="@/assets/images/imgqr/icon_weixin_joinus_qr.png"
              width="220"
            />
          </b-popover>
        </div>
      </b-col>
      <b-col cols="1"> </b-col>
      <b-col cols="2">
        <div class="cols-div">
          <img
            class="img-ico"
            src="@/assets/images/contact-advisory-guanzhu.png"
          />
          <p class="p-title text-center">关注公众号</p>
          <p class="p-phone text-center">关注我们的公众号</p>
          <b-button class="btn-from text-center" id="popoverSecond"
            >二维码</b-button
          >
          <b-popover
            target="popoverSecond"
            placement="top"
            triggers="hover focus"
          >
            <img
              src="@/assets/images/imgqr/icon_weixin_gzh_qr.png"
              width="220"
            />
          </b-popover>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import constant from "@/assets/constant";
export default {
  name: "ContactAdvisory",
  data() {
    return {
      phone: constant.phoneNo
    };
  }
};
</script>

<style lang="stylus" scoped>
.div-bg {
  height: 25rem;
  margin-top: 10rem;

  .cols-div {
    background-color: #ffffff;
    box-shadow: 0rem 0.3rem 0.8rem 0rem rgba(2, 0, 0, 0.11);
    height: 14.8rem;
    width: 11.8rem;
    border-radius: 0.9rem;

    .img-ico {
      width: 30%;
      margin-top: 20%;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .p-title {
      position: relative;
      font-size: 1.9rem;
      color: #333333;
      top: 1rem;
    }

    .p-phone {
      position: relative;
      font-size: 1rem;
      color: #666666;
    }

    .btn-from {
      position: relative;
      background-color: #12b7f6;
      border-radius: 0.8rem;
      height: 1.7rem;
      width: 5.1rem;
      font-size: 0.8rem;
      line-height: 0.9rem;
      // top 0.5rem
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/contact/components/ContactAdvisory.vue